import React, { useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { Card } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Store } from 'lucide-react';
import toast from 'react-hot-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AUTO = '__auto__';

export const StoreMappingPanel = () => {
  const [data, setData] = useState(null);
  const load = useCallback(() => {
    axios.get(`${API}/flujo-sync/stores`).then(r => setData(r.data)).catch(e => toast.error(e.response?.data?.detail || 'No se pudo cargar tiendas'));
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async (storeId, value) => {
    try {
      await axios.put(`${API}/flujo-sync/stores/${storeId}`, { flujo_tienda_id: value === AUTO ? null : value });
      toast.success('Tienda enlazada');
      load();
    } catch (e) { toast.error('No se pudo guardar'); }
  };

  if (!data) return null;
  if (data.error) return (
    <Card className="p-5 bg-white dark:bg-slate-900 border-red-200 dark:border-red-900" data-testid="store-mapping-error">
      <p className="text-sm text-red-600 dark:text-red-400">{data.error}</p>
    </Card>
  );
  return (
    <Card className="p-5 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800" data-testid="store-mapping-panel">
      <h2 className="font-semibold text-slate-800 dark:text-slate-100 flex items-center gap-2 mb-1">
        <Store className="h-4 w-4 text-[#2c57c5]" /> Tiendas Portal → Flujo de Caja
      </h2>
      <p className="text-xs text-slate-500 dark:text-slate-400 mb-3">Se enlazan solas por el correo de la tienda (ID del Flujo) o por nombre; si alguna no coincide, elígela manualmente.</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {data.stores.map(s => (
          <div key={s.id} className="flex flex-col sm:flex-row sm:items-center gap-2 rounded-md border border-slate-200 dark:border-slate-800 px-3 py-2" data-testid={`store-map-${s.id}`}>
            <span className="text-sm font-medium text-slate-700 dark:text-slate-200 sm:w-1/2 truncate">{s.nombre}</span>
            <Select value={s.manual ? s.flujo_tienda_id : AUTO} onValueChange={(v) => save(s.id, v)}>
              <SelectTrigger className={`sm:w-1/2 h-9 ${s.flujo_tienda_id ? '' : 'border-red-400 text-red-600'}`} data-testid={`store-map-select-${s.id}`}>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value={AUTO}>{s.manual ? 'Automático (por nombre)' : (s.flujo_nombre ? `Auto: ${s.flujo_nombre}` : 'Sin enlazar (no sincroniza)')}</SelectItem>
                {data.flujo_tiendas.map(t => <SelectItem key={t.id} value={t.id}>{t.nombre}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </Card>
  );
};
